import axiosInstance from '../axiosInterceptor/axiosInstance'

// Backend (BUS-2798 Social slice): PUT /api/v1/orgs/{orgId}/social/accounts with the page token
// in the body (connect is idempotent — reconnecting overwrites the stored credentials in place).
// orgId is passed in by the caller (single source of truth); a federation scopes the connection
// to a competition by passing competitionId (null/undefined = org level).
const postMetaAccessToken = ({ orgId, accessToken, competitionId }) => {
  return axiosInstance.put(`v1/orgs/${orgId}/social/accounts`, {
    accessToken,
    ...(competitionId ? { competitionId } : {}),
  })
}

export default postMetaAccessToken
